<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1016 7.26647L8.09121 13.2769C6.72437 14.6437 4.50829 14.6437 3.14146 13.2769C1.77462 11.91 1.77462 9.69396 3.14146 8.32713L9.15187 2.31672C10.0631 1.4055 11.5405 1.40549 12.4517 2.31672C13.3629 3.22794 13.3629 4.70533 12.4517 5.61655L6.67699 11.3913C6.22138 11.8469 5.48269 11.8469 5.02708 11.3913C4.57147 10.9356 4.57147 10.197 5.02708 9.74134L10.0947 4.67374"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
